(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-mega"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();
      this.setHeaderTopOffset();

      window.matchMedia('(max-width: 990px)').addEventListener('change', () => {
        this.setHeaderHeight();
        this.setHeaderTopOffset();
      });

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
      this.createAnnouncementBarObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    setHeaderTopOffset() {
      const announcementBar = document.querySelector('.announcement-bar-section');
      let topOffset = 0;

      if (announcementBar && announcementBar.offsetHeight > 0) {
        // Use the actual height of the announcement bar
        topOffset = announcementBar.offsetHeight;
      }

      document.documentElement.style.setProperty('--header-top-offset', `${topOffset}px`);

      // Also update collection filter position
      if (typeof updateCollectionFilterTopOffset === 'function') {
        updateCollectionFilterTopOffset();
      }
    }

    createAnnouncementBarObserver() {
      const announcementBar = document.querySelector('.announcement-bar-section');
      if (!announcementBar) return;

      // Observe the announcement bar for visibility changes
      this.announcementBarObserver = new MutationObserver(() => {
        this.setHeaderTopOffset();
      });

      // Also observe resize events
      const resizeObserver = new ResizeObserver(() => {
        this.setHeaderTopOffset();
      });

      this.announcementBarObserver.observe(announcementBar, {
        attributes: true,
        attributeFilter: ['style', 'class'],
        childList: true,
        subtree: true,
      });

      resizeObserver.observe(announcementBar);
      this.resizeObserver = resizeObserver;
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      if (this.announcementBarObserver) {
        this.announcementBarObserver.disconnect();
      }
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Set header top offset for all headers (including non-sticky ones)
  function updateHeaderTopOffset() {
    const announcementBar = document.querySelector('.announcement-bar-section');
    let topOffset = 0;

    if (announcementBar && announcementBar.offsetHeight > 0) {
      topOffset = announcementBar.offsetHeight;
    }

    document.documentElement.style.setProperty('--header-top-offset', `${topOffset}px`);
    updateCollectionFilterTopOffset();
  }

  // Set collection filter top offset (positioned below header)
  function updateCollectionFilterTopOffset() {
    const announcementBar = document.querySelector('.announcement-bar-section');
    const header = document.querySelector('.section-header');
    const collectionFilter = document.querySelector('collection-filter');

    if (!collectionFilter) return;

    let filterTopOffset = 0;

    // Add announcement bar height if visible
    if (announcementBar) {
      const announcementHeight = announcementBar.offsetHeight || 0;
      if (announcementHeight > 0) {
        filterTopOffset += announcementHeight;
      }
    }

    // Add header height - use getBoundingClientRect for more accurate measurement
    if (header) {
      const headerHeight = header.offsetHeight || header.getBoundingClientRect().height || 0;
      if (headerHeight > 0) {
        filterTopOffset += headerHeight;
      }
    }

    // Set the CSS variable
    document.documentElement.style.setProperty('--collection-filter-top-offset', `${filterTopOffset}px`);

    // Also apply directly to the element to ensure it works (overrides Tailwind)
    collectionFilter.style.top = `${filterTopOffset}px`;
  }

  // Initial update - run after DOM is ready
  function initializeOffsets() {
    updateHeaderTopOffset();
    // Also update after delays to ensure all elements are rendered
    setTimeout(updateHeaderTopOffset, 100);
    setTimeout(updateCollectionFilterTopOffset, 150);
    setTimeout(updateCollectionFilterTopOffset, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeOffsets);
  } else {
    initializeOffsets();
  }

  // Also run on window load to catch any late-loading elements
  window.addEventListener('load', () => {
    setTimeout(updateCollectionFilterTopOffset, 100);
  });

  // Watch for announcement bar changes
  function setupAnnouncementBarObserver() {
    const announcementBar = document.querySelector('.announcement-bar-section');
    const header = document.querySelector('.section-header');

    if (announcementBar) {
      const observer = new MutationObserver(() => {
        updateHeaderTopOffset();
        updateCollectionFilterTopOffset();
      });
      observer.observe(announcementBar, {
        attributes: true,
        attributeFilter: ['style', 'class'],
        childList: true,
        subtree: true,
      });

      const resizeObserver = new ResizeObserver(() => {
        updateHeaderTopOffset();
        updateCollectionFilterTopOffset();
      });
      resizeObserver.observe(announcementBar);

      // Also update on window resize
      window.addEventListener('resize', () => {
        updateHeaderTopOffset();
        updateCollectionFilterTopOffset();
      });
    }

    // Watch for header size changes
    if (header) {
      const headerResizeObserver = new ResizeObserver(() => {
        updateCollectionFilterTopOffset();
      });
      headerResizeObserver.observe(header);
    }

    // Watch for collection-filter element to appear in DOM
    const collectionFilterObserver = new MutationObserver(() => {
      const collectionFilter = document.querySelector('collection-filter');
      if (collectionFilter) {
        updateCollectionFilterTopOffset();
      }
    });
    collectionFilterObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupAnnouncementBarObserver);
  } else {
    setupAnnouncementBarObserver();
  }

  } catch(e) { console.error(e); }
})();
})();
